import {components, DropdownIndicatorProps} from 'react-select'
import {ChevronRightIcon} from '../SvgIcon'

interface OptionType {
  label: string
  value: string
  url?: string
}

export const DropdownIndicator = (
  props: DropdownIndicatorProps<OptionType, boolean>,
) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronRightIcon
        classes="rotate-90"
        strokeColor={props.selectProps.isDisabled ? 'text-gray-1100' : 'white'}
      />
    </components.DropdownIndicator>
  )
}
